module.exports = __webpack_public_path__ + "static/atelier.ef653cbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/atelier.jpg
// module id = 500
// module chunks = 136956383308509